$(document).ready(function(){
  function bundleDiscount(x) {
    if (x == 0) {
      $(".bundle-discount").removeClass("selected last");
    } else if (x == 1) {
      $(".bundle-discounts").attr("data-current-percent", "0");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected last");
    } else if (x == 2) {
      $(".bundle-discounts").attr("data-current-percent", "15");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected last");
    } else if (x == 3) {
      $(".bundle-discounts").attr("data-current-percent", "16");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected last");
    } else if (x == 4) {
      $(".bundle-discounts").attr("data-current-percent", "17");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected last");
    } else if (x == 5) {
      $(".bundle-discounts").attr("data-current-percent", "20");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(5)").addClass("selected last");
    } else if (x == 6) {
      $(".bundle-discounts").attr("data-current-percent", "25");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(5)").addClass("selected last");
    } else {
      $(".bundle-discounts").attr("data-current-percent", "30");
      $(".bundle-discount").removeClass("selected last");
      $(".bundle-discounts .bundle-discount:nth-child(1)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(2)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(3)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(4)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(5)").addClass("selected");
      $(".bundle-discounts .bundle-discount:nth-child(6)").addClass("selected last");
    }
    bundlePrice(x);
  }
  
  function bundlePrice(x) {
    var price = 0;
    $(".bundle-products .row .product-custom-grid").each(function () {
      if ($(this).find(".bundle-product").hasClass("selected")) {
        var p = parseInt($(this).find(".product-card-img").data("price"));
        var qty = parseInt($(this).find(".quantity-input").val());
        price = price + p * qty;
      }
    });
    const totalPrice = arrayList.reduce((total, item) => total + (item.price * item.quantity), 0);
    console.log(totalPrice);
    price = totalPrice;
    if (x == 0) {
      $("#valueBundle").text("");
      $("#valueBundleWithDiscount").text("");
    } else if (x == 1) {
      $("#valueBundle").text("");
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(price, moneyFormat));
    } else if (x == 2) {
      var discount_price = price * 0.85;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    } else if (x == 3) {
      var discount_price = price * 0.84;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    } else if (x == 4) {
      var discount_price = price * 0.83;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    } else if (x == 5) {
      var discount_price = price * 0.8;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    } else if (x == 6) {
      var discount_price = price * 0.75;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    } else {
      var discount_price = price * 0.7;
      $("#valueBundle").text(Shopify.formatMoney(price, moneyFormat));
      $("#valueBundleWithDiscount").text(Shopify.formatMoney(discount_price, moneyFormat));
    }
    if (x < 2) {
      $("#valueDiscount").text("");
    } else {
      var saving = price - discount_price;
      $("#valueDiscount").text(Shopify.formatMoney(saving, moneyFormat));
    }
  }
  
  function updateQuantityByVariantId(items, variantId, newQuantity) {
    
    return items.map(item => 
      item.id === variantId 
        ? { ...item, quantity: newQuantity } 
        : item
    );
  }

  function calculateQuantityByProductId(items, productId) {
    return items.filter(item => item.productId === productId)
                .reduce((total, item) => total + parseInt(item.quantity, 10), 0);
  }
  

  function getQuantityById(items, variantId) {
    const item = items.find(item => item.id === variantId);
    return item ? item.quantity : null;
  }
  

  function addItem(_parents) {        
    const variantId = _parents.find("select").val();
    const variantName = _parents.find("select").find(":selected").text();
    const qty = parseInt(_parents.find("#quantity").val(), 10);
    const price = _parents.find(".product-card-img").data('price');
    const image = _parents.find(".product-card-img").data('image');
    const productId = _parents.find(".product-card-img").data('product-id');

    const totalQuantity = arrayList.reduce((total, item) => total + item.quantity, 0) + qty;
    
    const resultQty = calculateQuantityByProductId(arrayList, productId);
    const totalQty = resultQty + qty;


    if (totalQuantity > 12) {
      alert('You can only add up to 12 items in your bundle!');
      _parents.removeClass("selected");
      return false;
    }    
  
    if (totalQty <= 3) {
      arrayList.push({ productId, quantity: qty, id: variantId, image: image, price: price, variantName: variantName });
    }
  }
  

  function removeItem(_parents) {
    const variantId = _parents.find("select").val();
    arrayList = arrayList.filter(item => item.id !== variantId);
  }

  function removeItemByVariantId(array, variantId) {
    return array.filter(item => item.id !== variantId);
  }  

  function updateQtyPlusButton(_parents, productId) {
    const resultQty = calculateQuantityByProductId(arrayList, productId);

    if (resultQty === 3) {
      _parents.find(".qtyplus").addClass("disabled");  
    }
    
  }

function renderVariantHtml() {
    let html = '';
    let i = 1;
    let t = 1;
    let j = 1;
  
    $('.bundle-summary-product').removeAttr('data-variant-added');
    $('.bundle-summary-product img').remove();
    $('.bundle-summary-product .variant--name, .bundle-summary-product .variant--qty').remove();
    $('.add-bundle-variants').html('');
    
    arrayList.forEach(item => {
        const { productId, quantity, id: variantId, image, variantName } = item;
    
        for (let k = 0; k < quantity; k++) {
            if (k === 0) {
                const $target = $(`.bundle-summary-products .bundle-summary-product:nth-child(${i})`);
                $target.attr('data-flag', t)
                    .append(`<img src="${image}" data-id="${variantId}">`)
                    .attr('data-variant-added', variantId);
    
                if (variantName !== "Default Title") {
                    $target.append(`<div class="variant--name">${variantName}</div>`);
                    $target.append(`<div class="variant--qty">${quantity}</div>`);
                } else {
                  $target.append(`<div class="variant--qty">${quantity}</div>`);
                }
            }
    
            html += `<input name="items[${j - 1}]id" value="${variantId}" data-id="${productId}" type="hidden">`;
            j++;
            if (k === 0) {
                i++;
            }
        }
    
        t++;
    });


    $('.add-bundle-variants').html(html);
  
    const totalQuantity = arrayList.reduce((total, item) => total + item.quantity, 0);
    bundleDiscount(totalQuantity);
    if (totalQuantity > 0) {
      $('.add-bundle-to-cart').removeAttr('disabled');  
      $('.bundle-summary-title #quantityProducts').text('('+totalQuantity+')');
    } else {
      $('.bundle-summary-title #quantityProducts').text('');
    }
    
}




  var arrayList = [];
  
  $(".bundle-product .product-card-img").on("click", function () {
    const _parents = $(this).parents(".bundle-product");

    const variantId = _parents.find("select").val();
    const productId = _parents.find(".product-card-img").data('product-id');
    const resultQty = calculateQuantityByProductId(arrayList, productId);
    const resultVariantQty = getQuantityById(arrayList, variantId);

    
    
    if (resultQty === 3 && !resultVariantQty) {
      return;
    }
      
    _parents.toggleClass("selected");
  
    if (_parents.hasClass("selected")) {
      addItem(_parents);
    } else {
      removeItem(_parents);
    }

  
    updateQtyPlusButton(_parents, productId);

    console.log("arrayList", arrayList);
    renderVariantHtml();
    
  })
  .on("click", ".qtydiv, .product-item__size", function (e) {
    e.stopPropagation();
  });
  

  $('.product-item__size select').change(function () {
    const _parents = $(this).parents(".bundle-product");
    const productId = _parents.find(".product-card-img").data('product-id');
    const variantId = $(this).val();

    const resultQty = calculateQuantityByProductId(arrayList, productId);
    const resultVariantQty = getQuantityById(arrayList, variantId);

    _parents.attr('data-variant', variantId);
    _parents.find('.product-card-img').attr('data-variant', variantId);
    
    console.log('resultQty : ', resultQty)
    if (resultQty < 3) {
      _parents.find(".qtyplus").removeClass("disabled");
    }
    
    if (resultVariantQty) {
      _parents.addClass("selected");
      _parents.find('#quantity').val(resultVariantQty);
      _parents.removeClass("disabled");
    } else {
      _parents.removeClass("selected");
      _parents.find('#quantity').val(1);
      if (resultQty === 3) {
        _parents.addClass("disabled");
      }
      if (resultQty === 2) {
        _parents.find(".qtyplus").addClass("disabled");
      }      
    }
  
    console.log("arrayList", arrayList);
    renderVariantHtml();
  });
  

 $(".qtybox .btnqty").on("click", function () {
    let totalQty = 0;
    let _parents = $(this).parents(".bundle-product");
    let productId = _parents.find(".product-card-img").data('product-id');
    const variantId = _parents.find("select").val();
    const resultQty = calculateQuantityByProductId(arrayList, productId);
    const resultVariantQty = getQuantityById(arrayList, variantId);
   
    const totalQuantity = arrayList.reduce((total, item) => total + item.quantity, 0);
   
    let qty = _parents.find(".quantity-input").val();
    totalQty = parseInt(qty) + parseInt(resultQty);

    console.log('qty: ', qty);
    console.log('totalQty: ', totalQty);
    
    $(this).find(".qtyplus") && $(this).toggleClass("disabled", resultQty == 3);

    if ($(this).hasClass("qtyplus")) {
      if (qty < 3) {
          qty++;

        let  sumQty = parseInt(qty) + parseInt(calculateQuantityByProductId(arrayList, productId));
        console.log('sumQty: ', sumQty);
        if (qty == 3 || totalQty == 3 || sumQty === 4) {
          $(this).addClass("disabled");
        }
      }
    } else {
      if (qty > 1) {
        qty--;
      }
     _parents.find(".qtyplus").removeClass("disabled");
    }
    qty = isNaN(qty) ? 1 : qty;

     if (resultVariantQty) {
      let sumQty = totalQuantity + qty
      console.log('totalQuantity totalQuantity', totalQuantity)
      console.log('sumQty sumQty', sumQty)
      if (sumQty > 14) {
        alert('You can only add up to 12 items in your bundle!');
        _parents.find(".qtyplus").addClass("disabled");
        return false;
      } else {           
        arrayList =  updateQuantityByVariantId(arrayList, variantId, qty);
      }
     }
    _parents.find(".quantity-input").val(qty);
   _parents.find(".qtyminus").removeClass("disabled");
     console.log("arrayList", arrayList);
    renderVariantHtml();
  });
    
  $('.add-bundle-to-cart').click(function(){
    setTimeout(function(){
      $(".product-card-img .quantity-input").val(1)
      $(".bundle-product").removeClass("selected");
      $('.bundle-summary-product').removeAttr('data-variant-added');
      $('.bundle-summary-product img').remove();
      $('.bundle-summary-product .variant--name, .bundle-summary-product .variant--qty').remove();
      $('#quantityProducts, #valueDiscount, #valueBundle, #valueBundleWithDiscount').text('');
      $('.bundle-discount').removeClass('selected');
      $('.add-bundle-to-cart').prop('disabled', true);
      arrayList = [];
    }, 1500);
  });
  
  $(".remove-from-bundle .icon-remove").click(function(){
    let _parents = $(this).parents(".bundle-summary-product");
    let variantId = _parents.find('img').data('id').toString();

    arrayList = removeItemByVariantId(arrayList, variantId);

    $(".product-card-item")
        .filter(function () {
            return $(this).data('variant') == variantId;
        })
        .removeClass('selected');

    
    renderVariantHtml();

    console.log('arrayList arrayList: ', arrayList)
  });

  $('.bundle-summary-open').click(function(){
    if($(window).width() < 1024){
      $(this).parent().toggleClass('active');
    }
  });
  
  
  

  $('.product-item__size select_s').change(function(){
      var id = $(this).val();
      var product_id = $(this).parents('.product-card-img').data('product-id');
    
      $(this).parents('.product-card-img').attr('data-variant', id);
      $('.add-bundle-variants [data-id="'+product_id+'"]').val(id);
      // CHOOSE SIZE
  });
  
  $(".bundle-product .product-card-img_s").on('click', function(e) {
    var c = 0;
    
    $('.bundle-products .row .product-custom-grid').each(function(){
      if($(this).find('.bundle-product').hasClass('selected')){
        var qty = $(this).find('.bundle-product .qtybox input').val();
        c = c + parseInt(qty);
      }
    });
    
    if(c < 12){
      var item_count = 0;
      if($(this).parents('.bundle-product').hasClass('selected')){
        $(this).find('.quantity-input').val('1');
        $(this).parent().find('.qtyplus').removeClass('disabled');
      }
      $(this).parents(".bundle-product").toggleClass("selected");
      // item_count = $('.bundle-product.selected').length;
      $('.bundle-products .row .product-custom-grid').each(function(){
        if($(this).find('.bundle-product').hasClass('selected')){
          var qty = $(this).find('.bundle-product .qtybox input').val();
          item_count = item_count + parseInt(qty);
        }
      });
      if(parseInt(item_count) > 0){
        $('.bundle-summary-title #quantityProducts').text('('+item_count+')');
        $('.add-bundle-to-cart').removeAttr('disabled');
      }else{
        $('.bundle-summary-title #quantityProducts').text('');
        $('.add-bundle-to-cart').prop('disabled', true);
      }
      bundleDiscount(item_count);
  
      var i = 1;
      var t = 1;
      var html = '';
      $('.bundle-summary-product').removeAttr('data-variant-added');
      $('.bundle-summary-product img').remove();
      $('.add-bundle-variants').html('');
      $('.bundle-products .row .product-custom-grid').each(function(){
        if($(this).find('.bundle-product').hasClass('selected')){
          var img_src = $(this).find('.product-card-img').data('image');
          var variant_id = $(this).find('.product-card-img').attr('data-variant');
          var product_id = $(this).find('.product-card-img').data('product-id');
          var n = parseInt($(this).find('.quantity-input').val());
          for(var k = 0; k<n; k++){
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-flag', t);
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').append('<img src="'+img_src+'" data-id="'+variant_id+'">');
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-variant-added', variant_id);
              j = i - 1;
              html += '<input name="items['+j+']id" value="'+variant_id+'" data-id="'+product_id+'" type="hidden">';
              i = i + 1;
          }
          t = t + 1;
        }
      });
      $('.add-bundle-variants').html(html);
      
    } else {
      
      if($(this).parents('.bundle-product').hasClass('selected')){
        var item_count = 0;
        $(this).parents(".bundle-product").toggleClass("selected");
        $(this).find('.quantity-input').val('1');
        $(this).parent().find('.qtyplus').removeClass('disabled');
        $('.bundle-products .row .product-custom-grid').each(function(){
          if($(this).find('.bundle-product').hasClass('selected')){
            var qty = $(this).find('.bundle-product .qtybox input').val();
            item_count = item_count + parseInt(qty);
          }
        });
        if(parseInt(item_count) > 0){
          $('.bundle-summary-title #quantityProducts').text('('+item_count+')');
          $('.add-bundle-to-cart').removeAttr('disabled');
        }else{
          $('.bundle-summary-title #quantityProducts').text('');
          $('.add-bundle-to-cart').prop('disabled', true);
        }
        bundleDiscount(item_count);
    
        var i = 1;
        var t = 1;
        var html = '';
        $('.bundle-summary-product').removeAttr('data-variant-added');
        $('.bundle-summary-product img').remove();
        $('.add-bundle-variants').html('');
        $('.bundle-products .row .product-custom-grid').each(function(){
          if($(this).find('.bundle-product').hasClass('selected')){
            var img_src = $(this).find('.product-card-img').data('image');
            var variant_id = $(this).find('.product-card-img').data('variant');
            var product_id = $(this).find('.product-card-img').data('product-id');
            var n = parseInt($(this).find('.quantity-input').val());
            for(var k = 0; k<n; k++){
                $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-flag', t);
                $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').append('<img src="'+img_src+'" data-id="'+variant_id+'">');
                $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-variant-added', variant_id);
                j = i - 1;
                html += '<input name="items['+j+']id" value="'+variant_id+'" data-id="'+product_id+'" type="hidden">';
                i = i + 1;
            }
            t = t + 1;
          }
        });
        $('.add-bundle-variants').html(html);
      }else{
        alert('You can only add up to 12 items in your bundle!');
      }
    }
    
  }).on('click', '.qtydiv, .product-item__size', function(e) {
    e.stopPropagation();
  });
  
  $('.bundle-summary-product_s').click(function(){
    var i = $(this).data('index');
    var temp = 0;
    var variant_id = parseInt($(this).find('img').data('id'));
    $('.bundle-products .row .product-custom-grid').each(function(){
      if($(this).find('.bundle-product').hasClass('selected')){
        var id = parseInt($(this).find('.bundle-product .product-card-img').data('variant'));
        var qty = parseInt($(this).find('.bundle-product .product-card-img .quantity-input').val());
        temp = temp + qty;
        if(id == variant_id){
          if(qty == 1){
            $(this).find('.bundle-product .product-card-img').trigger('click');
          }else{
            $(this).find('.bundle-product .product-card-img .qtyminus').trigger('click');
          }
        }
      }
    });
  });

  $('.bundle-summary-open_s').click(function(){
    if($(window).width() < 1024){
      $(this).parent().toggleClass('active');
    }
  });

  $('.add-bundle-to-cart_s').click(function(){
    setTimeout(function(){
      $(".bundle-product").removeClass("selected");
      $('.bundle-summary-product').removeAttr('data-variant-added');
      $('.bundle-summary-product img').remove();
      $('#quantityProducts, #valueDiscount, #valueBundle, #valueBundleWithDiscount').text('');
      $('.bundle-discount').removeClass('selected');
      $('.add-bundle-to-cart').prop('disabled', true);
    }, 1500);
  });

  $('.qtybox .btnqty_s').on('click', function(){
    var c = 0;
    $('.bundle-products .row .product-custom-grid').each(function(){
      if($(this).find('.bundle-product').hasClass('selected')){
        var qty = $(this).find('.bundle-product .qtybox input').val();
        c = c + parseInt(qty);
      }
    });

          var plus = $(this).hasClass('qtyplus');
          var minus = $(this).hasClass('qtyminus');
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
            if(qty < 3) {
              if(c < 12){
                qty++;
              }
              if(qty == 3){
                $(this).addClass('disabled');
              }
            }
          }else {
            if(qty > 1) {
              qty--;
            }
            $(this).parent().find('.qtyplus').removeClass('disabled');
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);

    if(plus && c < 12 || minus && c <= 12){
      if($(this).parents('.bundle-product').hasClass('selected')){
        var item_count = 0;
        $('.bundle-products .row .product-custom-grid').each(function(){
          if($(this).find('.bundle-product').hasClass('selected')){
            var qty = $(this).find('.bundle-product .qtybox input').val();
            item_count = item_count + parseInt(qty);
          }
        });
        if(parseInt(item_count) > 0){
          $('.bundle-summary-title #quantityProducts').text('('+item_count+')');
          $('.add-bundle-to-cart').removeAttr('disabled');
        }else{
          $('.bundle-summary-title #quantityProducts').text('');
          $('.add-bundle-to-cart').prop('disabled', true);
        }
        bundleDiscount(item_count);
    
        var i = 1;
        var t = 1;
        var html = '';
        $('.bundle-summary-product').removeAttr('data-variant-added');
        $('.bundle-summary-product img').remove();
        $('.add-bundle-variants').html('');
        $('.bundle-products .row .product-custom-grid').each(function(){
          if($(this).find('.bundle-product').hasClass('selected')){
            var img_src = $(this).find('.product-card-img').data('image');
            var variant_id = $(this).find('.product-card-img').data('variant');
            var product_id = $(this).find('.product-card-img').data('product-id');
            var n = parseInt($(this).find('.quantity-input').val());
            for(var k = 0; k<n; k++){
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-flag', t);
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').append('<img src="'+img_src+'" data-id="'+variant_id+'">');
              $('.bundle-summary-products .bundle-summary-product:nth-child('+i+')').attr('data-variant-added', variant_id);
              j = i - 1;
              html += '<input name="items['+j+']id" value="'+variant_id+'" data-id="'+product_id+'" type="hidden">';
              i = i + 1;
            }
            t = t + 1;
          }
        });
        $('.add-bundle-variants').html(html);
      }else{
        var x = parseInt($(this).parents('.product-card-img').find('.quantity-input').val());
        var t = c + x;
        if(t <= 12){
          $(this).parents('.product-card-img').trigger('click');
        }else{
          alert('You can only add up to 12 items in your bundle!');
          $(this).parents('.product-card-img').find('.quantity-input').val('1');
        }
      }
    }else{
      if($(this).hasClass('qtyplus')) {
        alert('You can only add up to 12 items in your bundle!');
        //$(this).parents('.product-card-img').find('.quantity-input').val('1');
      }
    }
    
  }); 

  
  
});


